import React from 'react'
import PropTypes from 'prop-types'
import FormattedContent from './FormattedContent'

function Message({ message, conversationId }) {
  const { role, content, created_at, isError } = message

  const formatTime = (timestamp) => {
    if (!timestamp) return ''
    const date = new Date(timestamp)
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
  }

  // Offer a styled XLSX download for persisted assistant answers with tables
  const hasTable = /\|[\s:]*-{3,}/.test(content)
  const exportable = role === 'assistant' && !isError && hasTable &&
    conversationId && message.id && message.persisted !== false

  return (
    <div className={`ai-message ai-message-${role} ${isError ? 'ai-message-error' : ''}`}>
      <div className="ai-message-header">
        <span className="ai-message-role">
          {role === 'user' ? 'You' : 'AI Assistant'}
        </span>
        <span className="ai-message-time">{formatTime(created_at)}</span>
      </div>
      <div className="ai-message-content">
        <FormattedContent content={content} />
      </div>
      {exportable && (
        <div className="ai-message-actions">
          <a
            className="ai-export-link"
            href={`/ai_conversations/${conversationId}/ai_messages/${message.id}/export.xlsx`}
          >
            ⬇ Download spreadsheet
          </a>
        </div>
      )}
    </div>
  )
}

Message.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    role: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    created_at: PropTypes.string,
    isError: PropTypes.bool,
    persisted: PropTypes.bool
  }).isRequired,
  conversationId: PropTypes.number
}

export default Message
